/** A link saved without a scheme gets `http://`, as v1 gave it. */
export function withScheme(url: string | null | undefined): string {
  if (!url) return '';
  const lower = url.toLowerCase();
  return lower.startsWith('http://') || lower.startsWith('https://')
    ? url
    : `http://${url}`;
}

/** The host a link shows: no query, no `www.`, no path. */
export function hostOf(url: string | null | undefined): string {
  return (url ?? '')
    .split(/[?#]/)[0]
    .replace(/^(?:https?:\/\/)?(?:www\.)?/i, '')
    .split('/')[0];
}
